import { render, staticRenderFns } from "./contributions-bar.component.vue?vue&type=template&id=7ac3c25a&"
import script from "./contributions-bar.component.vue?vue&type=script&lang=ts&"
export * from "./contributions-bar.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports